

import { useState } from "react";
import { Card } from "@material-ui/core";
import { Box, Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import api from "../../../../../services/api";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../../utils/buttonLeft";
import FazerObservacoes from "../../../../components/fazerObservacoes.";
import TextoFormatado from "../../../../../utils/textoFormatado";
import AddImagens from "./addImagens";
import DeleteAnalise from "./deleteAnalise";


export default function AnaliseInspeccaoVisualFisica({ avaliacaoId, ficha, analises, handleClose }) {
    // const { avaliacaoId } = useParams()
    const dispatch = useDispatch()
    const [avaliacao, setAvaliacao] = useState()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const [outrasObs, setOutrasObs] = useState('')
    const user = useSelector(state => state.account.user);
    // console.log(avaliacaoId)

    function HandleChange(e) {
        setAvaliacao((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const submitAvaliacao = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(avaliacao)

        const formData = new FormData();
        formData.append('userId', user?._id);
        formData.append('avaliacaoAnaliticaId', avaliacaoId);
        formData.append('observacao', obs);
        formData.append('outrasObservacoes', outrasObs);
        formData.append('cor', avaliacao?.cor ?? '');
        formData.append('nome', avaliacao?.nome ?? '');
        formData.append('formaFarmaceutica', avaliacao?.formaFarmaceutica ?? '');
        formData.append('danosFisicos', avaliacao?.danosFisicos ?? '');
        formData.append('tamanhoForma', avaliacao?.tamanhoForma ?? '');
        formData.append('uniformidadeCor', avaliacao?.uniformidadeCor ?? '');
        formData.append('uniformidadeForma', avaliacao?.uniformidadeForma ?? '');
        formData.append('referenciaBibliografica', avaliacao?.referenciaBibliografica ?? '');
        formData.append('resultado', avaliacao?.resultado ?? '');
        if (avaliacao?.imagens) {
            for (let imagem of avaliacao?.imagens) { formData.append('imagens', imagem ?? ''); }
        }
        await api.patch('/avalicao-analitica/teste/inspeccao-visual-fisica', formData)
            .then(res => {
                setMessageSuccess(res.data.msg)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Análise inserida com sucesso' },
                });
                handleClose();

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setOpen(false))
    }

    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );


    return (
        <Card style={{ padding: 15, marginTop: 20, minWidth: 700 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs title={'Analise fisica e Visual'} />
            {ficha ?
                <>
                    <DeleteAnalise url={'/avalicao-analitica/delete/teste/inspeccao-visual-fisica'} id={avaliacaoId} />
                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <Grid container spacing={2}>
                            {renderField('Cor', analises.cor)}
                            {renderField('Nome', analises.nome)}
                            {renderField('Forma Farmacêutica', analises.formaFarmaceutica)} 
                            {renderField('Fabricante', analises.danosFisicos)}
                            {renderField('Danos Fisico', analises.tamanhoForma)}
                            {renderField('Uniformidade de Cor', analises.uniformidadeCor)}
                            {renderField('Uniformidade de Forma', analises.uniformidadeForma)}
                            {renderField('Bibliografica', analises.referenciaBibliografica)}
                            {renderField('Resultado', analises.resultado)}
                        </Grid>
                    </Box>
                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Observação:</strong>  <TextoFormatado texto={analises?.observacao ?? ''} /> </Typography>
                    </Box>
                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Outras Observações:</strong>  <TextoFormatado texto={analises?.outrasObservacoes ?? ''} /> </Typography>
                    </Box>

                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <AddImagens avaliacao={analises} />
                    </Box>
                </>
                :
                <>
                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Nome"
                                fullWidth
                                size="small"
                                name="nome"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.nome}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="cor"
                                fullWidth
                                size="small"
                                name="cor"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.cor}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Forma Farmacêutica"
                                fullWidth
                                size="small"
                                name="formaFarmaceutica"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.formaFarmaceutica}
                            />
                        </Grid>
                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Tamanho Forma"
                                fullWidth
                                size="small"
                                name="tamanhoForma"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.tamanhoForma}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Uniformidade de Forma"
                                fullWidth
                                size="small"
                                name="uniformidadeForma"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.uniformidadeForma}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="uniformidade de Cor"
                                fullWidth
                                size="small"
                                name="uniformidadeCor"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.uniformidadeCor}
                            />
                        </Grid>

                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Danos Fisícos"
                                fullWidth
                                size="small"
                                name="danosFisicos"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.danosFisicos}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Referência Bibliografica"
                                fullWidth
                                size="small"
                                name="referenciaBibliografica"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.referenciaBibliografica}
                            />
                        </Grid>
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Resultado"
                                select
                                fullWidth
                                size="small"
                                name="resultado"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={avaliacao?.resultado || ''}
                            >
                                <MenuItem value={'Aprovado'} name="resultado">
                                    Aprovado
                                </MenuItem>
                                <MenuItem value={'Reprovado'} name="resultado">
                                    Reprovado
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <FazerObservacoes setObs={setObs} obs={obs} titulo={''} />
                    <FazerObservacoes setObs={setOutrasObs} obs={outrasObs} titulo={'Outras observvaçōes'} />

                    <AddImagens
                        addImagens={true}
                        avaliacao={avaliacao}
                        setAvaliacao={setAvaliacao}
                    />

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={submitAvaliacao}
                        load={open}
                    >
                        <Button onClick={handleClose} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    </ButtonLeft>
                </>
            }
        </Card>
    )
}